<template>
  <div
    class="page"
    :class="{
      'safe-padding': showSafePadding,
      'justify-height': keyboardChange,
      'hide-header': hideHeader
    }"
  >
    <div v-if="!hideHeader" class="page-header">
      <Back v-if="!hideBack" class="page-header-back"></Back>
      <h1 class="page-header-title">{{ title }}</h1>
      <Close
        v-if="isInSdk"
        class="page-header-close"
        @click="this.closeWebview"
      ></Close>
    </div>
    <div class="page-main">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import justifyFullScreen from '@mixins/officialPassport/justifyFullScreen';
import sdkBridge from '@mixins/officialPassport/sdkBridge';

export default {
  name: 'PageHeader',
  mixins: [justifyFullScreen, sdkBridge],
  props: {
    title: {
      type: String,
      default: ''
    },
    hideBack: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyboardChange: false
    };
  },
  mounted() {
    this.keyboardListener();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.judgeKeyboardState);
  },
  methods: {
    keyboardListener() {
      window.addEventListener('resize', this.judgeKeyboardState);
    },
    // 处理键盘弹出之后页面高度异常且无法拖动问题。修改一下高度会自动恢复
    judgeKeyboardState() {
      this.keyboardChange = !this.keyboardChange;
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  $headerHeight: 80px;
  position: relative;
  min-height: 100vh;
  background-color: var(--page-bgColor);
  &.justify-height {
    min-height: 100.001vh;
  }
  &-header {
    z-index: 2;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: $headerHeight;
    margin-bottom: 60px;
    background-color: var(--block-bg-color);
    font-size: 24px;
    line-height: $headerHeight;
    color: var(--text-color);

    &-back {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 42px;
      margin: auto;
    }

    &-close {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 42px;
      margin: auto;
      font-size: 30px;
    }
    &-title {
      font-size: 24px;
      font-weight: bold;
      text-align: center;
    }
  }
  &-main {
    box-sizing: border-box;
    min-height: 100vh;
    padding: ($headerHeight + 60px) 60px 60px;
    background-color: var(--page-bgColor);
  }

  &.hide-header {
    .page-main {
      padding-top: 60px;
    }

    &.safe-padding {
      .page-main {
        padding-top: calc(var(--safe-padding) + 60px);
      }
    }
  }

  &.safe-padding {
    .page-header {
      padding-top: var(--safe-padding);
      height: calc(var(--safe-padding) + $headerHeight);
      &-back,
      &-close {
        padding-top: var(--safe-padding);
      }
    }
    .page-main {
      padding-top: calc(var(--safe-padding) + $headerHeight + 60px);
    }
  }
}

// 阿拉伯语兼容
html[dir='rtl'] .page-header-back {
  /*!rtl:ignore*/
  transform: rotate(180deg);
}
html[dir='rtl'] .safe-padding .page-header-back {
  /*rtl:begin:ignore*/
  padding-top: 0;
  padding-bottom: var(--safe-padding);
  /*rtl:end:ignore*/
}
</style>

<style lang="scss" scoped>
.layout-passport.landScape {
  .page {
    &-main {
      max-width: 573px + 30px * 2;
      margin: auto;
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
